// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custBtn {
    background-color: #1abc9c;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  .custBtn:hover {
    background-color: #16a085;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
  }

  .customModal{
    background-color: #172639;
    color: white;
  }

  .cstmIcon{
    background-color: #16a085;
    color: white;
    border-radius: 20px;
  }

  /* customModal.css */
.customModal .close {
  color: orange!important;
}

.customModal .close:hover {
  color: darkorange!important;
}

.customBorder {
  border: 1px solid lightgray;
  padding: 15px;
  border-radius: 5px;
}

.small-font {
  font-size: 12px; /* Adjust the size as needed */
}

`, "",{"version":3,"sources":["webpack://./src/pages/VirtualMeeting.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kDAAkD;EACpD;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;EACrB;;EAEA,oBAAoB;AACtB;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,8BAA8B;AACjD","sourcesContent":[".custBtn {\n    background-color: #1abc9c;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: background-color 0.3s, box-shadow 0.3s;\n  }\n  \n  .custBtn:hover {\n    background-color: #16a085;\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);\n  }\n\n  .customModal{\n    background-color: #172639;\n    color: white;\n  }\n\n  .cstmIcon{\n    background-color: #16a085;\n    color: white;\n    border-radius: 20px;\n  }\n\n  /* customModal.css */\n.customModal .close {\n  color: orange!important;\n}\n\n.customModal .close:hover {\n  color: darkorange!important;\n}\n\n.customBorder {\n  border: 1px solid lightgray;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.small-font {\n  font-size: 12px; /* Adjust the size as needed */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
